export enum AnalysisStep {
    CannotAccessAnalysis,
    None,
    Validation,
    Interpretation,
    Signature,
}
